import React, {Component} from 'react'
import BaseUserListItem from '../../base/UserListItem/index'
import UserListItemContextMenu from '../UserListItemContextMenu/index'
import UserListItemContextMenuMobile from '../UserListItemContextMenuMobile/index'

import {getUserCSSClass} from '../BobTVUser/index'

class UserListItem extends BaseUserListItem {
    constructor(props) {
        super(props);

        this.onLeftClickDesktop = this.onLeftClickDesktop.bind(this);
        this.onLeftClickMobile = this.onLeftClickMobile.bind(this);
        this.onRightClick = this.onRightClick.bind(this);
    }


    getAdditionalClasses(currentUser, user) {
        var additionalClasses = [];

        if (user.audio) additionalClasses.push("audio");
        // if (streaming.isWatchingMe(user.ufrag)) additionalClasses.push("watching");
        
        if (user.streams && Object.values(user.streams).length > 1) {
            additionalClasses.push("streaming-multiple")
        } else {
            if (user.streaming) additionalClasses.push("streaming");
        }

        if (user.isAnonymous()) additionalClasses.push("anonymous");
        if (user.nick == currentUser.nick) additionalClasses.push("me");
        if (user.isXXL()) additionalClasses.push("pro");

        return additionalClasses;
    }

    onLeftClickDesktop(event) {
        let {user, openVideoWindow} = this.props;

        openVideoWindow(user.ufrag);
    }

    onLeftClickMobile(event) {
        let {onClickMobile, user} = this.props;

        onClickMobile(user);
    }

    onRightClick(event) {
        event.preventDefault();
        event.persist();
        let {user, currentUser, currentRoom, openVideoWindow} = this.props;

        this.contextMenu = UserListItemContextMenu.mount({
            user,
            currentUser,
            currentRoom,
            afterCloseFn: this.props.onContextMenuHidden,
            openVideoWindow,
            ref: (r) => {
                this.contextMenu = r;

                this.contextMenu.setAnchor(event.target);
                this.contextMenu.position();
                this.contextMenu.open();

                this.props.onContextMenuShown();
            }
        });

        
    }

    shouldComponentUpdate(nextProps, nextState) {
        for (var i in this.props) {
            if (this.props[i] !== nextProps[i]) {
                return true;
            }
        }

        return false;
    }

    render() {
        let {user, currentUser, currentRoom, browser, isWatchingMe, isWatched, selectedMobile, hideRightSidebar, onContextMenuHidden, openVideoWindow} = this.props;

        let additionalClasses = this.getAdditionalClasses(currentUser, user);
        let userClass = getUserCSSClass(currentUser, user);

        if (isWatchingMe) additionalClasses.push('watching');
        if (isWatched) additionalClasses.push('watched');
        if (selectedMobile) additionalClasses.push('context-menu-shown');

        let generosityRank = !currentUser.isUserBlocked(user) && user.generosity_rank ? 'generosity right-panel rank-'+user.generosity_rank : '';

        return (
            <li unselectable="on"
                className={'popup-opener ' + additionalClasses.join(' ')}
                onContextMenu={this.onRightClick}
                onMouseEnter={this.props.onMouseEnter ? (event) => this.props.onMouseEnter(event, user, isWatchingMe, this) : null}
                onMouseMove={this.props.onMouseMove ? (event) => this.props.onMouseMove(event, user, isWatchingMe, this) : null}
                onMouseLeave={this.props.onMouseLeave ? (event) => this.props.onMouseLeave(event, user, isWatchingMe, this) : null}
                onClick={browser.mobile ? this.onLeftClickMobile : undefined}>
                <span className={`user-type-icon ${userClass}`}>
                    <span className={`user-icon-message ${generosityRank} ${user.gift_rank ? 'not-only' : ''}`}/>
                </span>
                <i onClick={!browser.mobile ? this.onLeftClickDesktop : undefined}>{user.nick}</i>
                <div className="user-status-icons icon-move">
                    <span className="vol"></span>
                    <span className="eye"></span>
                    <span className="video"></span>
                </div>
                {selectedMobile && <UserListItemContextMenuMobile
                                        user={user}
                                        currentUser={currentUser}
                                        currentRoom={currentRoom}
                                        hideRightSidebar={hideRightSidebar}
                                        onContextMenuHidden={onContextMenuHidden}
                                        openVideoWindow={openVideoWindow}
                                    />
                }
            </li>
        )
    }
}

export default UserListItem;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserListItem/index.js